import {
  faUser as freeFasFaUser,
  faCog as freeFasFaCog,
  faBuilding as freeFasFaBuilding,
  faLocationDot as freeFasFaLocationDot,
  faHouse as freeFasFaHouse,
  faTruck as freeFasFaTruck,
  faPersonWalking as freeFasFaPersonWalking,
  faBicycle as freeFasFaBicycle,
  faBus as freeFasFaBus,
  faTriangleExclamation as freeFasFaTriangleExclamation,
  faVolumeHigh as freeFasFaVolumeHigh,
  faMapLocationDot as freeFasFaMapLocationDot,
  faClipboard as freeFasFaClipboard,
  faCheck as freeFasFaCheck,
  faPhone as freeFasFaPhone,
  faShieldAlt as freeFasFaShieldAlt,
  faLock as freeFasFaLock,
  faHeadset as freeFasFaHeadset,
  faEnvelope as freeFasFaEnvelope,
  faExclamationCircle as freeFasFaExclamationCircle,
  faMicrophone as freeFasFaMicrophone,
  faVolumeUp as freeFasFaVolumeUp,
  faComment as freeFasFaComment,
  faSpinner as freeFasFaSpinner,
  faBed as freeFasFaBed,
  faBath as freeFasFaBath,
  faRulerCombined as freeFasFaRulerCombined
} from '@fortawesome/free-solid-svg-icons'

import {
  faUser as freeFarFaUser
} from '@fortawesome/free-regular-svg-icons'

export default {freeFasFaUser, freeFasFaCog, freeFasFaBuilding, freeFasFaLocationDot, freeFasFaHouse, freeFasFaTruck, freeFasFaPersonWalking, freeFasFaBicycle, freeFasFaBus, freeFasFaTriangleExclamation, freeFasFaVolumeHigh, freeFasFaMapLocationDot, freeFasFaClipboard, freeFasFaCheck, freeFasFaPhone, freeFasFaShieldAlt, freeFasFaLock, freeFasFaHeadset, freeFasFaEnvelope, freeFasFaExclamationCircle, freeFasFaMicrophone, freeFasFaVolumeUp, freeFasFaComment, freeFasFaSpinner, freeFasFaBed, freeFasFaBath, freeFasFaRulerCombined, freeFarFaUser}